import { GenericControl } from "./Control";
import { GenericControlParams } from "./ControlInterfaces";
/**Aktualne slouzi pouze jako predek pro GenericPages a ToolbarGroups */
export class GenericControlCollection extends GenericControl {
    //#region Constructors
    constructor(params: GenericControlParams) {
        super(params);
    }

    //#region Constructors
}
